export default "__VITE_ASSET__JSaB9QW8__"